import React from 'react';

import KudosBluredComponent from 'Shared/components/KudosBluredComponent/KudosBluredComponent';
import { VideoType } from 'Shared/constants/types';

type Props = {
  feedback: {
    creatorId: number;
    likeThatText?: string;
    likeThatVideo?: VideoType;
    gifUrl?: string;
  };
  creatorFirstName: string;
  onClear: Function;
};

export default function FeedbackRecognitionContent({ onClear, feedback, creatorFirstName }: Props) {
  const { likeThatText, likeThatVideo, gifUrl } = feedback;

  const hint = `${creatorFirstName} gave you kudos! View it now!`;
  return (
    <div className="d-flex w-100 flex-column justify-content-center align-items-center cursor-pointer">
      <KudosBluredComponent
        hint={hint}
        likeThatText={likeThatText}
        likeThatVideo={likeThatVideo}
        onClear={onClear}
        gifUrl={gifUrl}
      />
    </div>
  );
}
